/**
 * Maps a controlled multi-choice selection onto option indices.
 * Duplicate option keys consume the first unused match each time.
 */
export function getSelectedOptionIndices(
  selection: ReadonlyArray<string>,
  optionKeys: ReadonlyArray<string>,
): Set<number> {
  const selectedIndices = new Set<number>()
  const usedIndices = new Set<number>()

  selection.forEach(key => {
    const index = optionKeys.findIndex((optionKey, optionIndex) => (
      optionKey === key && !usedIndices.has(optionIndex)
    ))
    if (index === -1) return
    selectedIndices.add(index)
    usedIndices.add(index)
  })

  return selectedIndices
}

export function haveSelectedIndicesChanged(
  currentIndices: ReadonlySet<number>,
  nextIndices: ReadonlySet<number>,
): boolean {
  if (currentIndices.size !== nextIndices.size) return true
  for (const index of currentIndices) {
    if (!nextIndices.has(index)) return true
  }
  return false
}
